import { Input } from '@builder.io/sdk';

import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

const resourceCardFields = [
  ...moleculeHeadingFields,
  {
    name: 'resources',
    type: 'list',
    subFields: [
      {
        name: 'resource',
        type: 'reference',
        helperText: 'Select a resource entry (blog, guide, etc.) to feature in this card.',
      },
    ],
    helperText: 'Choose up to 3 resources to display. Each item references an existing resource entry.',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      if (options.get('resources').length > 3) {
        options.set('resources', options.get('resources').slice(0, 3));
        alert('Maximum resource count is 3. Removing excess resources.');
      }
    },
  },
  {
    name: 'isDarkMode',
    type: 'boolean',
    defaultValue: false,
    helperText:
      'Switch this card deck to the dark theme (dark background and dark cards). Leave off for the default light style.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const resourceCardDeckConfig = {
  name: 'ResourceCardDeck',
  inputs: resourceCardFields,
};

export interface ResourceCardDeckConfigProps extends Omit<GenerateBuilder<typeof resourceCardFields>, 'resources'> {
  resources: { resource: BlogReference }[];
}

export default resourceCardDeckConfig;
